var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstonia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.992634C22.3139 0.993106 22.6743 1.12635 22.9401 1.36315C23.2059 1.59994 23.3555 1.92097 23.356 2.25585V19.962C23.3555 20.2968 23.2059 20.6179 22.9401 20.8547C22.6743 21.0914 22.3139 21.2247 21.938 21.2252H2.06201C1.6861 21.2247 1.32572 21.0914 1.05991 20.8547C0.7941 20.6179 0.644523 20.2968 0.643994 19.962V2.25585C0.644523 1.92097 0.7941 1.59994 1.05991 1.36315C1.32572 1.12635 1.6861 0.993106 2.06201 0.992634H21.938ZM21.938 0.418945H2.06201C1.5153 0.419417 0.991126 0.613107 0.604541 0.957488C0.217956 1.30187 0.000529505 1.76882 0 2.25585V19.962C0.000529505 20.449 0.217956 20.9159 0.604541 21.2603C0.991126 21.6047 1.5153 21.7984 2.06201 21.7989H21.938C22.4845 21.7979 23.0084 21.6041 23.3949 21.2598C23.7813 20.9155 23.9989 20.4488 24 19.962V2.25585C23.9995 1.76882 23.782 1.30187 23.3955 0.957488C23.0089 0.613107 22.4847 0.419417 21.938 0.418945Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 0.992676H2.06194C1.68602 0.993147 1.32565 1.12639 1.05984 1.36319C0.794027 1.59998 0.64445 1.92101 0.643921 2.25589V7.54562H23.3559V2.25589C23.3554 1.92101 23.2058 1.59998 22.94 1.36319C22.6742 1.12639 22.3138 0.993147 21.9379 0.992676Z",
    fill: "#008DCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3559 7.54541H0.643921V14.672H23.3559V7.54541Z",
    fill: "#010102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 19.9621C0.64445 20.297 0.794027 20.618 1.05984 20.8548C1.32565 21.0916 1.68602 21.2248 2.06194 21.2253H21.9379C22.3138 21.2248 22.6742 21.0916 22.94 20.8548C23.2058 20.618 23.3554 20.297 23.3559 19.9621V14.6724H0.643921V19.9621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstonia);
export default __webpack_public_path__ + "static/media/Estonia.782d7a5ecacbaa489c04495008bca834.svg";
export { ForwardRef as ReactComponent };